import { render, staticRenderFns } from "./TransferApplication.vue?vue&type=template&id=070f8178&scoped=true&"
import script from "./TransferApplication.vue?vue&type=script&lang=js&"
export * from "./TransferApplication.vue?vue&type=script&lang=js&"
import style0 from "./TransferApplication.vue?vue&type=style&index=0&lang=less&"
import style1 from "./TransferApplication.vue?vue&type=style&index=1&id=070f8178&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070f8178",
  null
  
)

export default component.exports